<template>
  <button v-if="loggedIn" class="favorites__button" @click="triggerFavorite">
    <img
      :src="currentFavorited ? heartIcon : heartOutlineIcon"
      width="25px"
      height="25px"
      alt
      class="ic-heart"
    />
    <span>お気に入り</span>
  </button>
  <button v-else class="favorites__button" @click="requireLogin">
    <img
      :src="heartOutlineIcon"
      width="25px"
      height="25px"
      alt
      class="ic-heart"
    />
    <span>お気に入り</span>
  </button>
</template>

<script>
import { debounce } from "lodash";
import heartIcon from "images/heart.svg";
import heartOutlineIcon from "images/heart-outline.svg";

export default {
  props: {
    loggedIn: {
      type: Boolean,
      required: true,
      default: false,
    },
    product: {
      type: Object,
      required: true,
    },
  },

  data: function () {
    return {
      heartIcon: heartIcon,
      heartOutlineIcon: heartOutlineIcon,
      currentFavorited: this.product.favorited,
      changeFavorite: false,
    };
  },

  methods: {
    triggerFavorite: function () {
      this.currentFavorited = !this.currentFavorited;
      this.toggleFavorites();
    },

    requireLogin: function () {
      this.$toasted.error("ログインしてください。", {
        duration: 800,
        theme: "bubble",
        onComplete: () => {
          this.$root.$refs.loginModal.open({
            redirectUrl: window.location.href,
          });
        },
      });
    },

    toggleFavorites: debounce(function () {
      const self = this;

      this.$axios.post(self.product.favorited_api_url, {
        current_favorited: self.currentFavorited,
      }).then(response => {
        self.changeFavorite = true;
        self.$emit('change', this.changeFavorite);
      });
    }, 300),
  },
};
</script>
